/* import __COLOCATED_TEMPLATE__ from './styles.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { notImplemented } from '@intercom/pulse/lib/computed-properties';
import * as IntercomEmbed from '@intercom/intercom-embed';
import AppColor from 'embercom/lib/color';
import tinycolor from 'tinycolor2';

export default Component.extend({
  tagName: '',
  appColor: notImplemented(),
  stylesheetBody: computed('appColor', function () {
    if (IntercomEmbed && IntercomEmbed.getStylesheet) {
      return IntercomEmbed.getStylesheet().replace(/-intercom-app-color/g, this.appColor);
    } else {
      return '';
    }
  }),
  applicationColors: computed('appColor', function () {
    return new AppColor().generate_message_box_colors(this.appColor);
  }),
  buttonBackgroundColor: computed('appColor', function () {
    let color = tinycolor(this.appColor);
    if (!color.isValid() || tinycolor.readability('#ffffff', color) >= 2) {
      return this.appColor;
    }
    // Primary blends into white card background — darken until visible
    for (let i = 5; i <= 60; i += 5) {
      let darkened = color.clone().darken(i);
      if (tinycolor.readability('#ffffff', darkened) >= 2) {
        return darkened.toRgbString();
      }
    }
    return '#000000';
  }),
  buttonTextColor: computed('buttonBackgroundColor', function () {
    let color = tinycolor(this.buttonBackgroundColor);
    if (!color.isValid()) {
      return '#ffffff';
    }
    return color.getLuminance() > 0.179 ? '#000000' : '#ffffff';
  }),
});
